import { render, staticRenderFns } from "./DateItem.vue?vue&type=template&id=c509cfba&scoped=true&"
import script from "./DateItem.vue?vue&type=script&lang=ts&"
export * from "./DateItem.vue?vue&type=script&lang=ts&"
import style0 from "./DateItem.vue?vue&type=style&index=0&id=c509cfba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c509cfba",
  null
  
)

export default component.exports